import textCell from '../text-cell'
import selectCell from '../select-cell'
import {
  // Select,
  // Form,
  // FormItem,
  Input,
  // Option,
  // OptionGroup,
  // Switch,
  // CheckboxGroup,
  // Checkbox,
  // RadioGroup,
  // Radio,
  // Button,
  // InputNumber,
  DatePicker
  // Cascader
} from 'element-ui'
// import asyncSelect from '../select-cell/async-select'
import asyncSelect from '../async-select'
// import { formatDate } from '../../../utils'
// const findObj = (arr, value, that) => {
//   if (that.group) { // 如果是select分组
//     let obj
//     const getObj = (options) => { // 递归查找
//       if (!options) {
//         return
//       }
//       obj = options.find(item => item.value === value || item.label === value)
//       if (obj) return obj
//       for (let item of options) {
//         obj = getObj(item.options)
//         if (obj) return obj
//       }
//     }
//     return getObj(arr)
//   }
//   return arr.find(item => item.value === value || item.label === value)
// }
// select的公用change默认事件定义
const selectDefalutChange = function () {
  // if (typeof this.value !== 'string') return
  // // 先根据value从options中找出对象
  // let obj = findObj(this.options || this.asyncSelect.options || [], this.value, this)
  // // 2018-7-24 17:22:59 记录筛选对象
  // this.valueObj = obj
  // text跟着最新的value/label变化
  this.text = this.value
}
/**
 * component: 组件
 * defaultChange: 绑定默认的change事件
 * validateEvent: 绑定表单验证的默认触发时机
 * getDefaultProps: 用于设置默认的props
 */
export default {
  'text': {
    component: textCell
  },
  'false': {
    component: textCell
  },
  'undefined': {
    component: textCell
  },
  'input': {
    component: Input,
    defaultChange () {
      this.text = this.value
      console.log('input:执行了默认的change事件')
    },
    getDefaultProps (item) {
      let label = item.label
      return {
        placeholder: label ? `请输入${label}` : ''
      }
    },
    validateEvent: 'blur'
  },
  'select': {
    component: selectCell,
    defaultChange: selectDefalutChange,
    validateEvent: 'change'
  },
  'async-select': {
    component: asyncSelect,
    validateEvent: 'change',
    defaultChange: selectDefalutChange
  },
  'date': {
    component: DatePicker,
    defaultChange () {
      if (typeof this.value === 'string') this.text = this.value
      // if (typeof this.value === 'object') this.text = formatDate(this.value)
      // console.log('select:执行了默认的change事件')
    },
    validateEvent: 'change'
  },
  'date-picker': {
    component: DatePicker,
    defaultChange () {
      if (typeof this.value === 'string') this.text = this.value
      // if (typeof this.value === 'object') this.text = formatDate(this.value)
      // console.log('select:执行了默认的change事件')
    },
    validateEvent: 'change'
  }
}
